import React, { Component } from 'react'

import Config from '../../config/Config';
import WidgetAjax from '../../widget/WidgetAjax';

import Management from './valuationModular/management';
import MarketPosition from './valuationModular/marketPosition';
import Profitability from './valuationModular/profitability';
import GrowthPotential from './valuationModular/growthPotential';
import FinancialPressure from './valuationModular/financialPressure';
import Bepres from './valuationModular/bepres';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';

import Widget from '../../widget/Widget';
import '../../css/common.css';
import { getDefaultNormalizer } from '@testing-library/react';

class valuation extends Component 
{
    constructor( props )
    {
        super(props);
        let UID = Config.getHermesPanoramaUID();
        
        let entname = Widget.getSessionStorage("entname");

        this.state = {
            basePath: Config.getBasePath(),
            nbUrl: Config.getBasePath()+'/entity/soc_secs',
            headerTop: null, // header到顶部的距离
            headerHeight: null, // header的高度
            consTops: [], 
            navList: [
                // {
                //   id: 'OPERATION',
                //   text: '营运能力'
                // },
                {
                  id: 'POSITION',
                  text: '市场地位'
                },
                {
                  id: 'PROFIT',
                  text: '盈利能力'
                },
                {
                  id: 'GROWTH',
                  text: '成长潜力'
                },
                {
                  id: 'nspj',
                  text: '纳税评级'
                },
                {
                  id: 'nbsb',
                  text: '年报社保信息'
                }
              ],
              POS:{
                ability_eslength_tp: "",
                ability_vendinc_tp: "",
                nic_name: "",
                ptil_pos: "",
                ptil_pos_eslength_tp: "",
                ptil_pos_indsy: "",
                ptil_pos_region: "",
                ptil_pos_vendinc_tp: "",
                r_illegal_all: "",
                r_pos_op: "",
                rank_amt_trd: "",
                rank_assgro: "",
                rank_pos: "",
                rank_pos_eslength_tp: "",
                rank_pos_indsy: "",
                rank_pos_region: "",
                rank_vendinc_tp: "",
                region_name: "",
                score_pos: "",
              },
              PRO:{
                ability_eslength_tp: "",
                ability_vendinc_tp: "",
                nic_name: "",
                ptil_pro: "",
                ptil_pro_eslength_tp: "",
                ptil_pro_indsy: "",
                ptil_pro_region: "",
                ptil_pro_vendinc_tp: "",
                r_illegal_all: "",
                r_pro_op: "",
                rank_mg_netinc: "",
                rank_mg_progro: "",
                rank_pro: "",
                rank_pro_eslength_tp: "",
                rank_pro_indsy: "",
                rank_pro_region: "",
                rank_pro_vendinc_tp: "",
                rank_roa: "",
                region_name: "",
                score_pro: ""
              },
              GRO:{
                ability_eslength_tp: "",
                ability_vendinc_tp: "",
                nic_name: "",
                ptil_gro: "",
                ptil_gro_eslength_tp: "",
                ptil_gro_indsy: "",
                ptil_gro_region: "",
                ptil_gro_vendinc_tp: "",
                r_gro_op: "",
                r_illegal_all: "",
                rank_gro: "",
                rank_gro_eslength_tp: "",
                rank_gro_indsy: "",
                rank_gro_region: "",
                rank_gro_vendinc_tp: "",
                rank_ir_amt_trd: "",
                rank_ir_progro: "",
                rank_ir_vendinc_tp: "",
                region_name: "",
                score_gro: ""
              },
              nsValue:'',
            nbcolumns:[
                {name:'INV', title:'年报年度', type:'string'},
                {name:'so110', title:'城镇职工基本养老保险参保人数', type:'string'},
                {name:'so210', title:'失业保险参保人数', type:'string'},
                {name:'so310', title:'职工基本医疗保险参保人数', type:'string'},
                {name:'so410', title:'工伤保险参保人数', type:'string'},
                {name:'so510', title:'生育保险参保人数', type:'string'},
                // {name:'totalpaymentso110', title:'城镇职工基本养老保险缴费基数', type:'string'},
                // {name:'totalpaymentso210', title:'失业保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso310', title:'职工基本医疗保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso410', title:'工伤保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso510', title:'生育保险本期实际缴费金额', type:'string'},
                // {name:'totalwagesso110', title:'参加城镇职工基本养老保险缴费基数', type:'string'},
                // {name:'totalwagesso210', title:'单位参加失业保险缴费基数', type:'string'},
                // {name:'totalwagesso310', title:'单位参加职工基本医疗保险缴费基数', type:'string'},
                // {name:'totalwagesso410', title:'单位参加工伤保险缴费基数', type:'string'},
                // {name:'totalwagesso510', title:'单位参加生育保险缴费基数', type:'string'},
                // {name:'unpaidsocialinsso110', title:'单位参加城镇职工基本养老保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso210', title:'单位参加失业保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso310 ', title:'单位参加职工基本医疗保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso410 ', title:'参加工伤保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso510 ', title:'单位参加生育保险累计欠缴金额', type:'string'},
            ],
            nbdata:[],
            params :{
                'user':UID,
                'ENTNAME' : entname
            },
        }
    }

    componentDidMount()
    {
        const { ENTNAME,curIndex } = this.props;
        
        this.getData(ENTNAME,'POS')
        this.getData(ENTNAME,'PRO')
        this.getData(ENTNAME,'GRO')
        this.getNspj()
    }

    componentDidUpdate()
    {
        let headerTopNew = this.header.offsetTop;
        let headerHeightNew =  this.header.clientHeight;
        let consTopsNew = [...this.main.children].map(item => item.offsetTop);
        if (this.state.consTops.length === 0)
        {
            this.setState({
                headerTop:headerTopNew,  
                headerHeight:headerHeightNew,
                consTops:consTopsNew
            });
        }
    }

    
    getNspj(){
        const { ENTNAME,curIndex } = this.props;
        let { basePath} = this.state;
        let data = {
            ENTNAME:ENTNAME
        }
        WidgetAjax.ajax({url:basePath + '/entity/tax_eval', params:data, callback:(result)=>{
            this.setState({
                nsValue:result.result.EVALS?result.results[0].EVALS:[]
            })
        }}); 
    }

    componentWillReceiveProps(nextprops) {
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
        let curIndex = this.state.curIndex;
        const {navList} = this.state

        // tabStyleClass.scrollTop + tabStyleClass.clientHeight >= tabStyleClass.scrollHeight


            this.state.consTops.forEach((top, index) => 
            {
                if (nextprops.scrollTop >= top-this.state.headerHeight - overviewWhiteHeight - tabStyleClass) 
                {
                    curIndex = index;
                }
                else if(nextprops.scrollTop === 0)
                {
                    curIndex = 0;
                }
                else if(nextprops.scrollTop + nextprops.clientHeight >= nextprops.scrollHeight )
                {
                    curIndex = navList.length-1;
                }
            })

            this.setState({ curIndex });
    }

 

    changeTab(e , id, index) 
    {
        // 点击导航跳转获取对应的位置，滚动位置
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
       
        this.props.setScrollTop(this.state.consTops[index] - this.state.headerHeight - tabStyleClass - overviewWhiteHeight);

        this.setState({
            curIndex: index,
            contentType: id+'_id'
        });
    }

    getData(ENTNAME,type){
        const { basePath } = this.state;
        WidgetAjax.ajax({ url: basePath + '/entity/financial_portrait', params: {ENTNAME,EVALTYPE:type}, callback: (e)=>{

            if(type=='POS'){
                this.setState({
                    POS:e.result.EVALS
                })
            }
            if(type=='PRO'){
                this.setState({
                    PRO:e.result.EVALS
                })
            }
            if(type=='GRO'){
                this.setState({
                    GRO:e.result.EVALS
                })
            }
            console.log(this.state.POS)
        } });
    }

    render()
    {
        const { navList, curIndex, POS,PRO,GRO,nbUrl,
            nbcolumns,nsValue,
            params,} = this.state;
        const { scrollTop } = this.props


        return (
            <div className="page entity-panorama">
                <div className="nav-height" ref={el => this.header = el}>
                    <div className="page-weidu entity-title"  style={this.props.headersHeight>0?{width:"936px",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}>
                    {/* <div className="page-weidu entity-title"  style={this.props.headersHeight>0?{width:"936px",position:"fixed",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}> */}
                      {navList.map((item, index) => (
                        <div
                          id={item.id}
                          className={['title-label', curIndex === index ? 'title-label title-label-active' : ''].join('')}
                          onClick={(e)=>this.changeTab(e, item.id , index)}
                        >{item.text}</div>
                      ))}
                    </div>
                </div>
                

                <div className="common-all">
                    <div className="common-box" ref={el => this.main = el}>
                        {/* <Management title={"营运能力"} options={operationOptions} ></Management> */}
                        <MarketPosition title={"市场地位"} options={POS} ></MarketPosition>
                        <Profitability title={"盈利能力"} options={PRO} ></Profitability>
                        <GrowthPotential title={"成长潜力"} options={GRO}></GrowthPotential>
                        <div className="content-top" style={{height:'auto',padding:0}}>
                            <div id="nspj_id" className="entity-baseInfo" style={{padding:0}}>
                                <div className="content-title">
                                    <div className="img">
                                        <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                                    </div>
                                    <div className="font">
                                        <span>纳税等级</span>
                                    </div>
                                </div>
                                <div className="baseInfo">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td >纳税信用等级</td>
                                                    <td>{nsValue?nsValue:'-'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                </div>
                            </div>
                        </div> 
                        <div id="nbsb_id" className="content-top"  style={{height:'auto',padding:0}}>
                            <div className="table-more">
                                <WidgetInterfaceTable options={{
                                    'url':nbUrl,
                                    'records':5,
                                    'title':'年报社保信息'
                                }} columns={nbcolumns} isNb={true} params={{...params}} />
                            </div>
                        </div> 
                        {/* <FinancialPressure title={"财务压力"} options={operationOptions}></FinancialPressure> */}
                        {/* <Bepres title={"营商环境压力"} options={operationOptions}></Bepres> */}
                        {/* <ValuationModular title={"市场地位"} options={positionOptions}></ValuationModular>
                        <ValuationModular title={"盈利能力"} options={profitOptions}></ValuationModular>
                        <ValuationModular title={"成长潜力"} options={growthOptions}></ValuationModular>
                        <ValuationModular title={"财务压力"} options={payableOptions}></ValuationModular>
                        <ValuationModular title={"营商环境压力"} options={berprsOptions}></ValuationModular> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default valuation